import React from 'react';
import PropTypes from 'prop-types';
import '../../../../../sass/apps/commerce/mobile/promo_code_form.scss';
import buildHiddenInputs from '../../../../helpers/hidden_input_builder';
import storageAvailable from '../../../../helpers/storage_available';

const PromoCodeForm = (props) => {
  function retainProduct() {
    if (storageAvailable('localStorage')) {
      sessionStorage.setItem(
        'failed_purchase',
        JSON.stringify({
          timestamp: Date.now(),
          products: [props.currentProduct],
        }),
      );
    }
  }
  return (
    <div className="promo-code-form">
      <label htmlFor="promo-code-input" className="promo-code-form__label">
        {props.localisations.enter_promo_code}
      </label>
      <div className="promo-code-form__close-wrapper">
        <i
          className="promo-code-form__error-icon far fa-exclamation-circle"
          style={{ display: props.errorVisible ? 'inline-block' : 'none' }}
        ></i>

        <button onClick={props.onClick} className="promo-code-form__close">
          {props.localisations.close}
        </button>
      </div>
      <form
        action={props.scriptPath}
        method="GET"
        name="promo-code-form"
        className="promo-code-form__form"
        id="promo-code-form"
      >
        {buildHiddenInputs({ M_context: props.context || null })}
        <input
          autoFocus
          id="promo-code-input"
          className="promo-code-form__field"
          type="text"
          name="promo_code"
        />
        <button
          onClick={retainProduct}
          className="button button--secondary promo-code-form__submit"
        >
          {props.localisations.redeem_code}
        </button>
      </form>
      <div
        className="promo-code-form__error"
        style={{ display: props.errorVisible ? 'block' : 'none' }}
      >
        {props.localisations.code_notvalid_expired}
      </div>
    </div>
  );
};

PromoCodeForm.propTypes = {
  scriptPath: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  context: PropTypes.string,
};

export default PromoCodeForm;
